import { Plus } from "lucide-react";
import { memo, useCallback } from "react";
import { SidebarFooter } from "@/components/ui/sidebar";
import useNewListStore from "@/stores/useNewListStore";
import { Button } from "../ui/button";
import { SidebarRunningTimer } from "./SidebarRunningTimer";
import SubscriptionNudge from "./SubscriptionNudge";
import VerifyEmailNudge from "./VerifyEmailNudge";

export const SidebarFooterComponent = memo(() => {
    const { setOpen: setNewListDialogOpen } = useNewListStore();

    //const { setOpen: setNewTaskDialogOpen } = useNewTaskStore();

    // const handleNewTaskClick = useCallback(() => {
    //     setNewTaskDialogOpen(true);
    // }, [setNewTaskDialogOpen]);

    const handleNewListClick = useCallback(() => {
        setNewListDialogOpen(true);
    }, [setNewListDialogOpen]);

    return (
        <SidebarFooter>
            <VerifyEmailNudge />
            <SubscriptionNudge />
            <div className="flex items-center gap-1 ml-2 mr-2 mb-2">
                <Button
                    onClick={handleNewListClick}
                    variant="default"
                    size="icon"
                    className="bg-zinc-300/70 text-zinc-500 hover:bg-zinc-400/50 hover:text-zinc-900"
                >
                    <Plus className="w-4 h-4" />
                </Button>
                <SidebarRunningTimer />
            </div>
        </SidebarFooter>
    );

    // return (
    //     <SidebarFooter>
    //         <DropdownMenu>
    //             <DropdownMenuTrigger render>
    //                 <Button variant="default" size="icon" className="bg-zinc-300/70 text-zinc-500 hover:bg-zinc-400/50 hover:text-zinc-900 ml-2 mb-2">
    //                     <Plus className="w-4 h-4" />
    //                 </Button>
    //             </DropdownMenuTrigger>
    //             <DropdownMenuContent align="start">
    //                 <DropdownMenuItem onClick={handleNewTaskClick}>
    //                     <div className="bg-background flex size-8 items-center justify-center rounded-md border">
    //                         <PlusSquare className="w-4 h-4" />
    //                     </div>
    //                     <div>
    //                         <div className=" font-medium leading-none">Task</div>
    //                         <div className="text-sm text-zinc-500">Create a single task</div>
    //                     </div>
    //                 </DropdownMenuItem>
    //                 <DropdownMenuItem onClick={handleNewListClick}>
    //                     <div className="bg-background flex size-8 items-center justify-center rounded-md border">
    //                         <List className="w-4 h-4" />
    //                     </div>
    //                     <div>
    //                         <div className=" font-medium leading-none">List</div>
    //                         <div className="text-sm text-zinc-500">Create a new tasklist</div>
    //                     </div>
    //                 </DropdownMenuItem>
    //             </DropdownMenuContent>
    //         </DropdownMenu>
    //     </SidebarFooter>
    // );
});
SidebarFooterComponent.displayName = "SidebarFooterComponent";
